export default __webpack_public_path__ + "static/media/bfast.3983d32d.png";